import React, { useMemo, useState } from "react";
import { useField } from "formik";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import AutocompleteMui from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

import Autocomplete from "../../../components/form/Autocomplete";
import Input from "../../../components/form/Input";
import movers from "../../../constants/movers";
import displayFields from "../../../constants/displayFields";
import { getOptions } from "src/utils/form";
import manufacturers from "src/constants/manufacturers";
import colors from "src/constants/colors";
import BooleanSelectField from "src/components/form/fields/BooleanSelectField";
import dispositions from "src/constants/dispositions";
import useFilterFields from "src/views/favoriteReport/fields/useFilterFields";

const FilterFields = ({ name }) => {
  const fields = useFilterFields();
  const [field, , helpers] = useField({ name });
  const labels = Object.fromEntries(fields);

  const fieldTypes = useMemo(() => ({
    disposition: {
      type: "select",
      label: "Filter By Disposition",
      options: getOptions(dispositions),
    },
    barcode: { type: "input", label: labels.barcode },
    origin_employee: { type: "input", label: "Filter By Orign Employee" },
    destination_employee: {
      type: "input",
      label: "Filter By Destination Employee",
    },
    checkout: {
      type: "select",
      label: "Filter By Mover",
      options: getOptions(movers),
    },
    manufacturer: {
      type: "select",
      label: displayFields.manufacturer,
      options: getOptions(manufacturers),
    },
    color: {
      type: "select",
      label: displayFields.color,
      options: getOptions(colors),
    },
  }));

  const options = useMemo(() => fields.map(([value, label]) => ({ value, label })), [fields]);
  const [inputValue, setInputValue] = useState("");

  return (
    <>
      <AutocompleteMui
        value={null}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
        }}
        onChange={(event, newValue) => {
          if (newValue) {
            helpers.setValue(field.value.concat({ type: newValue.value, value: "" }));
            setInputValue("");
          }
        }}
        options={options}
        getOptionLabel={option => option.label}
        renderInput={params => (
          <TextField
            {...params}
            label="Choose a Field to Filter By +"
            variant="outlined"
            size="small"
            fullWidth
          />
        )}
      />
      <Box mt={3} />
      {field.value.length > 0 ? (
        field.value.map((v, i) => {
          const { type, label, options } = fieldTypes[v.type] || {
            type: "input",
            label: labels[v.type],
          };
          return (
            <React.Fragment key={i}>
              {i > 0 && <Box mt={1} />}
              <Box display="flex" alignItems="center">
                {type === "select" ? (
                  <Autocomplete
                    name={`${name}.${i}.value`}
                    label={label || displayFields[v.type]}
                    options={options}
                    saveCustomOption
                  />
                ) : type === "boolean" ? (
                  <BooleanSelectField
                    name={`${name}.${i}.value`}
                    label={label || displayFields[v.type]}
                  />
                ) : type === "input" ? (
                  <Input name={`${name}.${i}.value`} label={label} />
                ) : null}
                <IconButton
                  id={`delete-${name}-${i}-value`}
                  variant="outlined"
                  onClick={() => helpers.setValue(field.value.filter((v, index) => i !== index))}
                >
                  <DeleteIcon color="action" />
                </IconButton>
              </Box>
            </React.Fragment>
          );
        })
      ) : (
        <Typography align="center" color="textSecondary">
          No filters applied
        </Typography>
      )}
    </>
  );
};

export default FilterFields;
